import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AprovacaoResolver } from 'src/app/services/resolvers/aprovacao.resolver';
import { ContractResolver } from 'src/app/services/resolvers/contract.resolver';
import { AprovacaoResumoComponent } from '../aprovacao-resumo/aprovacao-resumo.component';
import { AprovacaoComponent } from './aprovacao.component';

const routes: Routes = [
  {
    path: ':contractNumber/:queryNumber/:financialInstitution',
    component: AprovacaoComponent,
    title: 'Aprovação de edição de proposta',
    resolve: { contracts: ContractResolver }

    // resolve: { contracts: ContractResolver },
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AprovacaoRoutingModule {}
